module.exports = __webpack_public_path__ + "img/atlaslist3img5.a668d629.jpg";